import { useState, forwardRef, useImperativeHandle } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const messageModal = forwardRef(({ status, size = "sm", children, customIcon = null, onClose, locked = false }, ref) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    onClose?.();
  };
  const handleShow = () => setShow(true);

  useImperativeHandle(ref, () => ({
    show: handleShow,
    hide: handleClose,
  }));

  let iconToShow = null;

  // 如果有自訂 icon，優先使用
  if (customIcon) {
    iconToShow = <FontAwesomeIcon icon={customIcon} className="icon mb-4" />;
  } else {
    switch (status) {
      case 'success':
        iconToShow = <FontAwesomeIcon icon="fa-solid fa-circle-check" className="icon mb-4" />;
        break;
      case 'error':
        iconToShow = <FontAwesomeIcon icon="fa-solid fa-circle-xmark" className="icon mb-4" />;
        break;
      case 'warning':
        iconToShow = <FontAwesomeIcon icon="fa-solid fa-circle-exclamation" className="icon mb-4" />;
        break;
      default:
        // 預設的情況
        iconToShow = null;
        break;
    }
  }

  return (
    <>
      <Modal
        size={size}
        show={show}
        onHide={handleClose}
        centered
        backdrop={locked ? 'static' : true}
        keyboard={!locked}
      >
        <Modal.Header className="border-bottom-0" closeButton={!locked}>
          {/* <Modal.Title>Modal heading</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            {iconToShow}
            <div>{children}</div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={handleClose}>
            Close
          </Button>
          <Button className="btn-primaryF" size="sm" onClick={handleClose}>
            Save
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  )
});
messageModal.displayName = 'MessageModal';

export default messageModal;